export function setLanguage(data) {
  return {
    type: "SETTING_LANGUAGE",
    data,
  };
}
